import { createTheme } from "@mui/material/styles";

import "./fonts.css";

// Shared MUI v5 theme with MUI v4-compatible defaults.
// All three bundles (visits, emr, patient-portal) use this theme.
const theme = createTheme({
  typography: {
    fontFamily: '"BasisGrotesquePro-Regular", "Helvetica", "Arial", sans-serif',
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  palette: {
    primary: {
      main: "#3f51b5", // MUI v4 default primary (indigo)
    },
    secondary: {
      main: "#f50057", // MUI v4 default secondary (pink)
    },
    error: {
      main: "#f44336", // MUI v4 default error (red)
    },
    warning: {
      main: "#ff9800", // MUI v4 default warning (orange)
    },
    info: {
      main: "#2196f3", // MUI v4 default info (blue)
    },
    success: {
      main: "#4caf50", // MUI v4 default success (green)
    },
  },
  components: {
    MuiLink: {
      defaultProps: {
        underline: "hover",
      },
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: false,
      },
    },
    MuiButton: {
      styleOverrides: {
        containedInherit: {
          "&:hover": {
            backgroundColor: "#999",
            color: "#fff",
          },
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          fontSize: "18px",
        },
      },
    },
    MuiCheckbox: {
      defaultProps: {
        color: "secondary",
      },
      styleOverrides: {
        root: {
          "& .MuiSvgIcon-root": {
            fontSize: "24px",
          },
        },
      },
    },
  },
});

export default theme;
